import { render, staticRenderFns } from "./ShipmentDialog.vue?vue&type=template&id=0b866483&scoped=true&"
import script from "./ShipmentDialog.vue?vue&type=script&lang=js&"
export * from "./ShipmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDialog.vue?vue&type=style&index=0&id=0b866483&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b866483",
  null
  
)

export default component.exports